var _defs, _circle, _g, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadgeEagle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "eg",
    cx: "35%",
    cy: "30%",
    r: "75%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#F0C75E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8922A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ec"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "url(#eg)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ec)",
    stroke: "#0B131E",
    strokeWidth: 1.6,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2 70 L2 52 C6 45 11 40 17 38 L41 37 C49 43 55 53 58 70 Z",
    fill: "#5A3A22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 46 l3 6 M19 44 l2 7 M27 44 l1 7 M35 44 l1 7 M43 45 l2 6",
    stroke: "#3B2414",
    strokeWidth: 1.2,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 40 C11 30 14 18 24 13 C32 9 41 11 46 17 L47 25 C46 30 44 34 41 37 L38 36 L36 40 L32 37 L28 41 L25 37 L21 41 L19 37 L15 42 Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 19 C50 18 56 21 58 27 C59 31 57 35 54 36 C55 32 53 30 50 30 L46 31 C45 29 45 24 44 19 Z",
    fill: "#F2B01E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 31 C48 33 50 33.5 52 32.5",
    fill: "none",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 19.5 C36 17.5 41 17 45 19",
    fill: "none",
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 23,
    r: 2.6,
    fill: "#E8A317"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.2,
    cy: 23,
    r: 1.2,
    fill: "#0B131E",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.7,
    cy: 22.4,
    r: 0.45,
    fill: "#FFFFFF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 22 C24 26 24 30 22 33 M28 27 C29 30 28 33 27 35",
    stroke: "#CBD5E1",
    strokeWidth: 1.1,
    fill: "none"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 31,
    fill: "none",
    stroke: "rgba(255,255,255,0.35)",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeEagle);
export default __webpack_public_path__ + "static/media/badge-eagle.7fe9216c3686ced5a0638157ff17f75b.svg";
export { ForwardRef as ReactComponent };